<div class="container">
  <h6 class="text-uppercase fw-bold mb-4">Zappi DQ changes A/B Testing</h6>

  <div class="d-flex align-items-center gap-3 mb-4">
    <label class="mb-0">A/B Testing Enabled</label>
    <div class="setting-info">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <p style="white-space: normal">
        Takes effect after Save. Turning this off and saving stops new
        transactions from being selected, but transactions already assigned keep
        running and history stays available.
      </p>
    </div>
    <ps-ui-capsule-radio-button
      class="capsule-button-row"
      [id]="'enableZappiAbTesting'"
      [value]="pendingEnabled"
      (valueChange)="pendingEnabled = $event"
    >
    </ps-ui-capsule-radio-button>
  </div>

  <h6 class="fw-bold">Upload A/B Test Configuration</h6>
  <div class="mb-2">
    <input
      type="file"
      class="form-control file-upload"
      accept=".csv"
      (change)="uploadFile($event)"
    />
  </div>
  <div class="d-flex align-items-start gap-2 mb-3">
    <i class="fa fa-info-circle formats-info-icon mt-1" aria-hidden="true"></i>
    <div class="text-muted">
      Supported CSV formats:
      <ul class="mb-0 ps-3">
        <li>
          Product Code, Market, Percentage
          <a
            class="download-button"
            href="assets/templates/zappi-ab-testing-product-market-template.csv"
          >
            Download Template
          </a>
        </li>
        <li>
          Survey ID, Count
          <a
            class="download-button"
            href="assets/templates/zappi-ab-testing-survey-template.csv"
          >
            Download Template
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="p-3">
    <button
      type="button"
      class="btn btn-primary save-button"
      [disabled]="saving || !configLoaded"
      (click)="save()"
    >
      Save
    </button>
  </div>

  <div class="row" *ngIf="skippedRows.length">
    <h6 class="fw-bold">Skipped Rows</h6>
    <table class="table">
      <thead>
        <tr>
          <th>Row</th>
          <th>Reason</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of skippedRows">
          <td>{{ row.row }}</td>
          <td>{{ row.reason }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <hr />

  <h6 class="fw-bold mb-3">Currently Running A/B Tests</h6>
  <table class="table zappi-running-table" *ngIf="combinedConfigs.length">
    <thead>
      <tr>
        <th>Type</th>
        <th>Configuration</th>
        <th>Percentage / Count</th>
        <th>Started On</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of combinedConfigs">
        <td>{{ row.type }}</td>
        <td>{{ row.configuration }}</td>
        <td>{{ row.value }}</td>
        <td>{{ row.startedOn }}</td>
        <td>
          <span
            class="badge rounded-pill status-badge"
            [class.status-badge-running]="row.status === 'Running'"
            [class.status-badge-stopped]="row.status !== 'Running'"
          >
            {{ row.status }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
  <p *ngIf="!combinedConfigs.length && !loading">
    No active A/B test configurations.
  </p>
</div>
